import { render, staticRenderFns } from "./infotime.vue?vue&type=template&id=047cd23e&scoped=true&"
import script from "./infotime.vue?vue&type=script&lang=js&"
export * from "./infotime.vue?vue&type=script&lang=js&"
import style0 from "./infotime.vue?vue&type=style&index=0&id=047cd23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047cd23e",
  null
  
)

export default component.exports